export default "__VITE_ASSET__fc121312__"